export default __webpack_public_path__ + "static/media/LEGA9010.46456563.jpg";